import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getArtifactType } from '../shared/artifactRegistry';
import { MAX_ARTIFACT_DEPTH } from '@erikdakoda/artifact/shared/artifactTypes';
import type { OpenArtifactHandler } from '@erikdakoda/markdown-ui/types';
import SelfScrollingArtifactFrame from './SelfScrollingArtifactFrame';

export { MAX_ARTIFACT_DEPTH };

type EmbeddedArtifactProps = {
  type: string;
  content: string;
  title?: string;
  artifactDepth?: number;
  onOpenArtifact?: OpenArtifactHandler;
  fillPanel?: boolean;
  contentReloadKey?: number;
};

/**
 * Renders artifact content by registry lookup. Used in the workspace panel and inline embeds.
 */
export default function EmbeddedArtifact({
  type,
  content,
  title,
  artifactDepth = 0,
  onOpenArtifact,
  fillPanel = false,
  contentReloadKey = 0,
}: EmbeddedArtifactProps) {
  'use memo';

  const definition = getArtifactType(type);

  if (definition) {
    const Component = definition.Component;
    return (
      <Component
        key={`${type}-${contentReloadKey}`}
        className="embedded-artifact"
        content={content}
        title={title}
        artifactDepth={artifactDepth}
        onOpenArtifact={onOpenArtifact}
        fillPanel={fillPanel}
        contentReloadKey={contentReloadKey}
      />
    );
  }

  if (fillPanel) {
    return (
      <SelfScrollingArtifactFrame className="embedded-artifact">
        <Box sx={{ p: 2 }}>
          <Typography
            variant="body2"
            component="pre"
            sx={{ fontFamily: 'monospace', fontSize: 12 }}
          >
            {content}
          </Typography>
        </Box>
      </SelfScrollingArtifactFrame>
    );
  }

  return (
    <Box className="embedded-artifact" sx={{ p: 2 }}>
      <Typography variant="body2" component="pre" sx={{ fontFamily: 'monospace', fontSize: 12 }}>
        {content}
      </Typography>
    </Box>
  );
}
